import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'sp0004',
    ecrans: ['00-2']
});
